<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      right
    
    >
      <v-list nav dense class="mt-1">
        <v-list-group>
          <template v-slot:activator>
            <v-list-item-title class="texto-drawer"
              >PRODUCTOS</v-list-item-title
            >
          </template>
          <v-list-group
            sub-group
            no-action
            v-for="(categoria, index) in categorias"
            :key="index"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title class="texto-drawer">{{
                  categoria.text
                }}</v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="(subcategoria, index_two) in categoria.subcategorias"
              :key="index_two"
            >
              <v-list-item-title
                class="texto-drawer"
              @click="redirigirPagina(subcategoria)"
                >{{ subcategoria.text }}</v-list-item-title
              >
            </v-list-item>
          </v-list-group>
        </v-list-group>
        <v-divider color="white"></v-divider>
        <v-list-item>
          <v-list-item-title class="texto-drawer">NOSOTROS </v-list-item-title>
        </v-list-item>
        <v-divider color="white"></v-divider>
        <v-list-item>
          <v-list-item-title class="texto-drawer">CONTACTO </v-list-item-title>
        </v-list-item>
        <v-divider color="white"></v-divider>
        <v-list-item class="d-flex justify-center mt-6">
          <v-btn color="#0071BC" id="btn-cotiza-ahora" dark>COTIZA AHORA</v-btn>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :height="validarAlturaNav"
      src="@/assets/images/manguera.png"
    >
      <v-col cols="12" class="pa-0 ma-0">
        <v-row class="pa-0 ma-0 mt-0 mt-sm-6">
          <v-col
            class="ma-0"
            cols="4"
            v-if="
              $vuetify.breakpoint.name != 'xs' &&
              $vuetify.breakpoint.name != 'sm'
            "
          ></v-col>
          <v-col
            class="ma-0 d-flex justify-start justify-sm-center justify-md-center justify-lg-center align-center"
            cols="8"
            sm="6"
            md="4"
            lg="4"
          >
            <img
              link
              @click="$router.push({ path: '/' })"
              src="@/assets/images/logo-svg.svg"
              alt="colimportados logo"
              style="max-width: 100%; max-height: 60px; cursor: pointer"
            />
          </v-col>
          <v-col
            cols="4"
            sm="6"
            md="4"
            lg="4"
            class="d-flex align-center justify-end pr-8"
          >
            <v-btn
              v-if="$vuetify.breakpoint.name != 'xs'"
              color="#0071BC"
              id="btn-cotiza-ahora"
              dark
              >cotiza ahora</v-btn
            >

            <!-- <v-btn icon @click="drawer = !drawer"><v-icon>mdi-menu</v-icon></v-btn> -->
            <v-app-bar-nav-icon
              x-large
              v-if="$vuetify.breakpoint.name == 'xs'"
              @click="drawer = !drawer"
            ></v-app-bar-nav-icon>
          </v-col>
        </v-row>

        <v-row
          justify="center"
          class="menu-categorias ma-0 mt-3"
          v-if="$vuetify.breakpoint.name != 'xs'"
        >
          <v-col
            style="height: 100%"
            cols="3"
            sm="2"
            md="1"
            lg="1"
            :style="mostrar_menu_categorias ? 'color:white' : ''"
            class="menu-seleccionable mx-sm-0 mx-md-3 mx-lg-0"
            @click="mostrar_menu_categorias = !mostrar_menu_categorias"
          >
            <h1>Productos</h1>
          </v-col>

          <v-col
            style="height: 100%"
            cols="3"
            sm="2"
            md="1"
            lg="1"
            class="menu-seleccionable d-flex"
          >
            <div style="border-left: 1px solid; color: black"></div>
            <v-spacer></v-spacer>
            <h1 class="mx-sm-0 mx-md-3 mx-lg-0">Nosotros</h1>
            <v-spacer></v-spacer>
            <div style="border-left: 1px solid; color: black"></div>
          </v-col>
          <v-col
            style="height: 100%"
            cols="3"
            sm="2"
            md="1"
            lg="1"
            class="menu-seleccionable mx-sm-0 mx-md-3 mx-lg-0"
          >
            <h1>Contacto</h1>
          </v-col>
          <v-col cols="12">
            <v-expand-transition v-if="$vuetify.breakpoint.name != 'xs'">
              <v-row
                class="menu-categorias-hover px-5 pb-3"
                style="
                  width: 100%;
                  position: absolute;

                  background-color: rgba(255, 255, 255, 0.9);
                "
                v-if="mostrar_menu_categorias"
                @mouseleave="mostrar_menu_categorias = false"
              >
                <v-col
                  cols="2"
                  sm="4"
                  md="3"
                  lg="2"
                  class="mb-n5"
                  v-for="(categoria, index) in categorias"
                  :key="index"
                >
                  <v-expansion-panels flat>
                    <v-expansion-panel
                      style="background-color: rgba(255, 255, 255, 0)"
                    >
                      <v-expansion-panel-header style="color: #0071bc"
                        ><h2 class="categoria-text">
                          {{ categoria.text }}
                        </h2></v-expansion-panel-header
                      >
                      <v-expansion-panel-content>
                        <h3
                          class="subcategorias-text"
                          v-for="(
                            subcategoria, index2
                          ) in categoria.subcategorias"
                          :key="index2"
                          @click="redirigirPagina(subcategoria)"
                        >
                          {{ subcategoria.text }}
                        </h3>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>
            </v-expand-transition>
          </v-col>
        </v-row>
      </v-col>
    </v-app-bar>
  </div>

  <!-- <div class="nav-bar">
    <nav >
      <v-row class="pa-0 ma-0 bar">
        <v-col
          class="ma-0"
          cols="4"
          v-if="
            $vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'
          "
        ></v-col>
        <v-col
          class="ma-0 d-flex justify-start justify-sm-center justify-md-center justify-lg-center align-center"
          cols="8"
          sm="6"
          md="4"
          lg="4"
        >
          <img
            link
            @click="$router.push({ path: '/' })"
            src="@/assets/images/logo-svg.svg"
            alt="colimportados logo"
            style="max-width: 100%; max-height: 60px; cursor: pointer"
          />
        </v-col>
        <v-col
          cols="4"
          sm="6"
          md="4"
          lg="4"
          class="d-flex align-center justify-end pr-8"
        >
          <v-btn
            v-if="$vuetify.breakpoint.name != 'xs'"
            color="#0071BC"
            id="btn-cotiza-ahora"
            dark
            >cotiza ahora</v-btn
          >

          <v-app-bar-nav-icon
            x-large
            v-if="$vuetify.breakpoint.name == 'xs'"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
        </v-col>
      </v-row>
      <v-row
        justify="center"
        class="menu-categorias py-2 ma-0"
        v-if="
          $vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'
        "
      >
        <v-col
          cols="3"
          sm="2"
          md="2"
          lg="1"
          :style="mostrar_menu_categorias ? 'color:white' : ''"
          class="menu-seleccionable"
          @click="mostrar_menu_categorias = !mostrar_menu_categorias"
        >
          Productos
        </v-col>
        <v-col cols="3" sm="2" md="2" lg="1" class="menu-seleccionable">
          Nosotros
        </v-col>
        <v-col cols="3" sm="2" md="2" lg="1" class="menu-seleccionable">
          Contacto
        </v-col>
      </v-row>
      <v-expand-transition
        v-if="
          $vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm'
        "
      >
        <v-row
          class="menu-categorias-hover ma-0 px-5 pb-3"
          style="
            width: 100%;
            position: absolute;
            background-color: rgba(255, 255, 255, 0.9);
          "
          v-if="mostrar_menu_categorias"
          @mouseleave="mostrar_menu_categorias = false"
        >
          <v-col
            cols="2"
            md="3"
            lg="2"
            class="mb-n5"
            v-for="(categoria, index) in categorias"
            :key="index"
          >
            <v-expansion-panels flat>
              <v-expansion-panel
                style="background-color: rgba(255, 255, 255, 0)"
              >
                <v-expansion-panel-header style="color: #0071bc"
                  ><h3 style="font-weight: 500">
                    {{ categoria.text }}
                  </h3></v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <h4 
                    class="subcategorias-text"
                    v-for="(subcategoria, index2) in categoria.subcategorias"
                    :key="index2"
                    @click="$router.push(`/subcategoria/${subcategoria.value}`)"
                  >
                    {{ subcategoria.text }}
                  </h4>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-expand-transition>
      <v-navigation-drawer v-model="drawer" fixed right>
        <v-list nav dense>
          <v-list-item-group active-class="deep-purple--text text--accent-4">
            <v-list-item>
              <v-list-item-title>Foo</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Bar</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Fizz</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-title>Buzz</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </nav>
  </div>   -->
</template>

<script>
export default {
  data: () => ({
    mostrar_menu_categorias: false,
    categorias: [
    {
        text: "MANGUERAS",
        value: "mangueras",
        subcategorias: [
          { text: "INDUSTRIALES", value: "industriales" },
          { text: "HIDRÁULICAS", value: "hidráulicas" },
        ],
      },
      {
        text: "ACOPLES",
        value: "acoples",
        subcategorias: [
          { text: "HIDRÁULICOS", value: "hidraulicos" },
          { text: "NEUMÁTICOS", value: "neumáticos" },
          { text: "OPW", value: "opw" },
        ],
      },
      {
        text: "PLÁSTICOS",
        value: "plásticos",
        subcategorias: [
          { text: "INDUSTRIALES", value: "plasticos-industriales" },
          { text: "INGENIERIA", value: "ingenieria" },
          { text: "ALTO RENDIMIENTO", value: "alto-rendimiento" },
        ],
      },
      {
        text: "SELLADO DE FLUIDOS",
        value: "sellado de fluidos",
        subcategorias: [
          { text: "DINÁMICO", value: "dinámico" },
          { text: "ESTÁTICO", value: "estático" },
        ],
      },
      {
        text: "VÁLVULAS",
        value: "válvulas",
        subcategorias: [
          { text: "SS", value: "ss" },
          { text: "BRONCE", value: "bronce" },
        ],
      },
      {
        text: "QUÍMICOS INDUSTRIALES",
        value: "químicos industriales",
        subcategorias: [
          { text: "LOCTITE", value: "loctite" },
          { text: "CRC", value: "crc" },
          { text: "MAGNAFLUX", value: "magnaflux" },
        ],
      },
      
      {
        text: "AISLAMIENTO TÉRMICO",
        value: "aislamiento térmico",
        subcategorias: [
          { text: "TELAS", value: "telas" },
          { text: "FIELTROS", value: "fieltros" },
          { text: "MANTAS", value: "mantas" },
          { text: "CINTAS", value: "cintas" },
        ],
      },
    ],
    drawer: false,
  }),
  computed: {
    validarAlturaNav() {
      if (this.$vuetify.breakpoint.name == "xs") {
        return 80;
      } else if (this.$vuetify.breakpoint.name == "md") {
        return 140;
      } else {
        return 150;
      }
    },
  },
  methods: {
    redirigirPagina(subcategoria) {
      if (this.$route.name == "subcategoria") {
        window.location.href = `/subcategoria/${subcategoria.value}`;
      } else {
        this.$router.push(`/subcategoria/${subcategoria.value}`);
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-toolbar__content {
  padding: 0px !important;
}

::v-deep v-expansion-panel-header v-expansion-panel-header--active {
  line-height: 0;
}

.texto-drawer {
  color: gray;
}

/* ::v-deep .v-toolbar__image {
  top:-1px;
}
 */

/* .nav-bar {
  width: 100%;
  min-height: 150px;
  max-height: 150px;
}
nav {
  width: 100%;
  position: relative;
  z-index: 999;
  box-shadow: 0 3px 5px -2px rgba(0, 0, 0, 0.75);
} */

/* .bar {
  background: url("@/assets/images/manguera.png") no-repeat;
  background-position-y: -1px;
  background-position-x: -1px;
} */

@media (max-width: 768px) {
  .bar {
    background: none;
    background-color: white;
  }
}
#btn-cotiza-ahora {
  animation: tilt-shaking 1s ease-out;
  text-transform: capitalize;
  font-size: calc(13px + 0.390625vw);
  font-weight: 500;
}

.menu-categorias {
  height: 40px;
  width: 100%;
  font-weight: 500;
  font-size: 0.8rem;
  text-align: center;
  background-color: #fbb03b;
}

/* .menu-categorias :nth-child(2) {

  border-left: 1px solid white;
  border-right: 1px solid white;
} */

.menu-seleccionable {
  padding: 10px 0px;
}

.menu-seleccionable:hover {
  transition: 0.2s;
  cursor: pointer;
  color: white;
  backface-visibility: 0.3;
}

.menu-seleccionable h1 {
  font-size: 0.9rem;
  font-weight: 500;
}

.categoria-text {
  font-size: 1rem;
  font-weight: 500;
}

.subcategorias-text {
  text-align: left;
  font-size: 1rem;
  font-weight: normal;
  cursor: pointer;
  transition: 0.3s;
}

.subcategorias-text:hover {
  color: #0071bc;
}

@media (max-width: 600px) {
}

@media (min-width: 601px) and (max-width: 960px) {
}

@media (min-width: 961px) {
  .menu-seleccionable {
    padding: 4px 0px;
  }

  .menu-categorias {
    height: 30px;
  }
}
</style>
